import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Section';
import { useLanguage } from './LanguageContext';
export function FAQ() {
  const {
    t
  } = useLanguage();
  const faqs = [{
    q: t('faq.q1'),
    a: t('faq.a1')
  }, {
    q: t('faq.q2'),
    a: t('faq.a2')
  }, {
    q: t('faq.q3'),
    a: t('faq.a3')
  }, {
    q: t('faq.q4'),
    a: t('faq.a4')
  }, {
    q: t('faq.q5'),
    a: t('faq.a5')
  }, {
    q: t('faq.q6'),
    a: t('faq.a6')
  }, {
    q: t('faq.q7'),
    a: t('faq.a7')
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-barber-dark border-y border-barber-lightGray" data-id="element-174">
      <div className="max-w-3xl mx-auto" data-id="element-175">
        <div className="text-center mb-12" data-id="element-176">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-barber-text uppercase mb-4" data-id="element-177">
            {t('faq.heading1')}{' '}
            <span className="text-barber-gold" data-id="element-178">{t('faq.heading2')}</span>
          </h2>
        </div>
        <div className="space-y-4" data-id="element-179">
          {faqs.map((faq, index) => <div key={index} className="bg-barber-black border border-barber-lightGray rounded-sm overflow-hidden" data-id="element-180">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 md:p-6 text-left focus:outline-none" data-id="element-181">
                <span className="font-heading text-lg md:text-xl font-bold text-barber-text uppercase tracking-wide pr-4" data-id="element-182">
                  {faq.q}
                </span>
                <ChevronDown className={`text-barber-gold shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-183" />
              </button>
              <AnimatePresence data-id="element-184">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-185">
                    <div className="p-5 md:p-6 pt-0 text-barber-muted text-lg border-t border-barber-lightGray/50 mt-2" data-id="element-186">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}